module.exports = __webpack_public_path__ + "static/img/lattu-logo.d0ae072.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lattu-logo.png
// module id = LFdq
// module chunks = 58